
import { Component, Vue } from "vue-property-decorator";
// import HeaderWebComponent from "@/components/Common/Web/HeaderWeb.vue"; // @ is an alias to /src
import HeaderWebComponent from "@/components/Common/Web/NewHeaderWeb.vue"; // @ is an alias to /src
import FooterWebComponent from "@/components/Common/Web/FooterWeb.vue"; // @ is an alias to /src
import FarmaciaPopup from "@/components/Common/Dialogs/FarmaciaPopup.vue";

@Component({
  components: {
    HeaderWebComponent,
    FooterWebComponent,
    FarmaciaPopup
  }
})
export default class BaseLayout extends Vue {}
